import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

const ExparienceParticipants = ({ open, handleClose, participants }) => {
  const { t } = useTranslation();

  return (
    <React.Fragment>
      <Dialog
        open={open}
        onClose={handleClose}
        scroll={"paper"}
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
      >
        <DialogTitle id="scroll-dialog-title">
          {t("myExpariences.onlineParticipants")}
        </DialogTitle>
        <DialogContent dividers sx={{ minHeight: "200px", width: "300px" }}>
          <Box
            id="scroll-dialog-description"
            tabIndex={-1}
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {participants.map((login, index) => (
              <Typography
                variant="body1"
                sx={{ marginBottom: "0.25rem" }}
                key={`login-${index + 1}`}
              >
                {login}
              </Typography>
            ))}
          </Box>
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
};

export default ExparienceParticipants;
